import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './NavigationContainer.scss';

// import NewHeader from '../../components/Shared/Header/NewHeader';
import MoneyMarketEventMessage from '../../components/Shared/MoneyMarketEventMessage/MoneyMarketEventMessage';
// import CustomerWebView from '../../components/CustomerWebView/CustomerWebView';
import { moduleActions } from '../../redux/modules';
import { getHasMoneyMarketEventMessage } from '../../redux/modules/moneyMarketEvent/moneyMarketEvent.selectors';
import { getUserMessageCount } from '../../redux/modules/user/PersonalInformation/personalInformation.selectors';
// import TopNav from '../../components/Navigation/TopNav/TopNav';
// import { getQueryStringValue } from '../../utils/utils';
import config from '../../config/config';
import { PRODUCT_TYPE_ENUM_MAP } from '../../settings/settings';
import {
  SecureNavigationBeacon,
  SecureNavigation,
} from '@trp-ii-ii-component-library/ii-components';
import {
  getIsMobileParam,
  isCustomerWebViewEnabled,
} from '../../redux/modules/authentication/authentication.module.selectors';
import { getUserFundList } from '../../redux/modules/shoppingCart/shoppingCart.selectors';
import {
  getExistingRMDSetting,
  getIsRMDEligible,
} from '../../redux/modules/RMD/RMDSetting.selectors';
import { getHasCollegeOnly } from '../../redux/modules/productTypes/productType.selectors';
require('animate.css/animate.min.css');

export class NavigationContainer extends Component {
  UNSAFE_componentWillMount() {
    const {
      actions: { getUserManager },
    } = this.props;
    getUserManager();
  }

  render() {
    const {
      // actions: getUserManager,
      customerWebViewEnabled,
      hasMoneyMarketEventMessage,
      messageCount,
      userProductTypes: { entity },
      userManager,
      userFunds,
      isMobileParam,
      isRMDEligible,
      RMDSetting,
      is529Only,
    } = this.props;
    const rm = userManager?.manager;
    const relationshipManager =
      userManager.isLoaded && rm?.person
        ? {
            email: rm.email,
            location: rm.location,
            person: rm.person,
            phone: rm.officePhone,
            title: rm.primaryJobTitle,
            headshot: `${config.rmlUrl}${rm.color96x96.path}`,
            profile: `${
              config.userUrl
            }${rm.person.firstName.toLowerCase()}-${rm.person.lastName.toLowerCase()}.html`,
          }
        : undefined;
    const {
      hasAPP,
      hasRAS,
      hasBrokerage,
      hasMutualFund,
      hasNAT529,
      hasMD529,
      hasAK529,
    } = entity;
    const accounts = [];
    if (hasMutualFund) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP['MUTUAL_FUND'] });
    }
    if (hasAK529) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP['ALASKA_529'] });
    }
    if (hasNAT529) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP['NATIONAL_529'] });
    }
    if (hasMD529) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP['MARYLAND_529'] });
    }
    if (hasBrokerage) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP['BROKERAGE'] });
    }
    if (hasAPP) {
      accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP['MANAGED_ACCOUNT'] });
    }
    if (hasRAS) {
      accounts.push({
        productType: PRODUCT_TYPE_ENUM_MAP['RETIREMENT_ADVISORY'],
      });
    }

    const agreementMap = {
      TRADITIONAL_IRA: 6,
      ROTH_IRA: 7,
      JOINT_TENANT_TOD: 26,
      ESA: 9,
      POA: 40,
    };
    const acctObj = userFunds
      .map((fund) => {
        const a = {
          productType: PRODUCT_TYPE_ENUM_MAP[fund.productType],
        };
        if (agreementMap[fund.agreementType]) {
          a.accountTypeId = agreementMap[fund.agreementType];
        }
        return a;
      })
      .concat(accounts);
    return isMobileParam ? null : is529Only ? (
      <div className="navigation-font">
        <SecureNavigation
          authentication={{
            authorization: {
              isCustomerWebView: customerWebViewEnabled,
              isAuthenticated: true,
            },
            loginUrl: '',
            user: {
              messageCount,
              relationshipManager,
              isRMDEligible:
                isRMDEligible || RMDSetting?.existingRMDData?.preRMDEligible,
            },
          }}
          data={{
            accounts: acctObj,
            showMainMenu: true,
            showContextualNav: true,
            brokerageTradingEnabled: true,
          }}
        />
        {hasMoneyMarketEventMessage ? <MoneyMarketEventMessage /> : ''}
      </div>
    ) : (
      <div className="navigation-font">
        <SecureNavigationBeacon
          authentication={{
            authorization: {
              isCustomerWebView: customerWebViewEnabled,
              isAuthenticated: true,
            },
            loginUrl: '',
            user: {
              messageCount,
              relationshipManager,
              isRMDEligible:
                isRMDEligible || RMDSetting?.existingRMDData?.preRMDEligible,
            },
          }}
          data={{
            accounts: acctObj,
            showMainMenu: true,
            showContextualNav: true,
            brokerageTradingEnabled: true,
          }}
        />
        {hasMoneyMarketEventMessage ? <MoneyMarketEventMessage /> : ''}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    actionPendingAuth,
    authentication,
    redirect,
    routing,
    user,
    userProductTypes,
    userManager,
  } = state;

  return {
    actionPendingAuth,
    authentication,
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    userFunds: getUserFundList(state),
    hasMoneyMarketEventMessage: getHasMoneyMarketEventMessage(state),
    isRMDEligible: getIsRMDEligible(state),
    messageCount: getUserMessageCount(state),
    RMDSetting: getExistingRMDSetting(state),
    redirect,
    routing,
    user,
    userProductTypes,
    userManager,
    isMobileParam: getIsMobileParam(state),
    is529Only: getHasCollegeOnly(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  NavigationContainer
);
